import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ListGroup from 'react-bootstrap/lib/ListGroup';
import ListGroupItem from 'react-bootstrap/lib/ListGroupItem';
import { toPlural, toSeoUrl } from 'helpers/HelperFunctions';
import Loader from 'components/Loader/Loader';
import Thumbnail from 'components/Thumbnails/Thumbnail';
import styles from './ProjectCredits.module.scss';
import LinkOrAnchor from 'components/Shared/LinkOrAnchor';

const ProjectCredits = ({
  credits,
  creditsTotal,
  loadingCredits,
  loggedInUser,
  more,
  onAddCredit,
  onLoadMore,
  owner,
}) => {
  const alreadyCredited = credits.findIndex((credit) => {
    if (loggedInUser && credit.user.id === loggedInUser.id) {
      return true;
    }

    return false;
  });

  const showOwnerFallback =
    !loadingCredits && credits.length === 0 && Boolean(owner);

  const creatorsLabel = showOwnerFallback
    ? 'Project creator'
    : !loadingCredits && credits.length === 0
    ? 'No project creators'
    : creditsTotal === 1
    ? 'Project creator'
    : 'Project creators';

  // While credits are empty, treat the owner as already credited so we don't
  // invite them to claim their own project.
  const ownerAlreadyShown =
    showOwnerFallback && loggedInUser && owner && loggedInUser.id === owner.id;

  return (
    <ListGroup className={styles.creditsGroup}>
      <ListGroupItem className={styles.creditsGroupItem}>
        <p className={styles.header}>{creatorsLabel}</p>
      </ListGroupItem>
      {showOwnerFallback ? (
        <ListGroupItem
          className={`${styles.creditsGroupItem} ${styles.credit}`}
        >
          <Link to={owner.links.main_relative} className={styles.avatarLink}>
            <Thumbnail
              circle
              className={styles.avatar}
              thumbnails={owner.avatars}
            />
          </Link>
          <div className={styles.wrapper}>
            <Link to={owner.links.main_relative}>
              <div className={styles.displayname}>{owner.displayname}</div>
            </Link>
          </div>
        </ListGroupItem>
      ) : (
        credits.map((credit, idx) => (
          <ListGroupItem
            key={idx}
            className={`${styles.creditsGroupItem} ${styles.credit}`}
          >
            <Link
              to={credit.user.links.main_relative}
              className={styles.avatarLink}
            >
              <Thumbnail
                circle
                className={styles.avatar}
                thumbnails={credit.user.avatars}
              />
            </Link>
            <div className={styles.wrapper}>
              <Link to={credit.user.links.main_relative}>
                <div className={styles.displayname}>
                  {credit.user.displayname}
                </div>
              </Link>
              <div className={styles.creditsList}>
                {credit.roles.map((role, roleIdx) => (
                  <span key={roleIdx}>
                    {roleIdx !== 0 ? ', ' : ''}
                    {loggedInUser ? (
                      <span className={styles.creditRole}>{role}</span>
                    ) : (
                      <LinkOrAnchor
                        isLink={false}
                        className={styles.creditLink}
                        title={`Find ${toPlural(role)}`}
                        to={`/find/${toSeoUrl(toPlural(role))}`}
                      >
                        {role}
                      </LinkOrAnchor>
                    )}
                  </span>
                ))}
              </div>
            </div>
          </ListGroupItem>
        ))
      )}
      {loadingCredits && (
        <ListGroupItem className={styles.creditsGroupItem}>
          <Loader loading />
        </ListGroupItem>
      )}
      {!loadingCredits && more ? (
        <ListGroupItem className={styles.creditsGroupItem}>
          <a className={styles.loadMore} onClick={() => onLoadMore()}>
            Load more...
          </a>
        </ListGroupItem>
      ) : null}
      {loggedInUser &&
      loggedInUser.type === 'seller' &&
      alreadyCredited < 0 &&
      !ownerAlreadyShown ? (
        <ListGroupItem className={styles.creditsGroupItem}>
          <a className={styles.addCredits} onClick={() => onAddCredit()}>
            Did you work on this?
          </a>
        </ListGroupItem>
      ) : null}
    </ListGroup>
  );
};

ProjectCredits.propTypes = {
  credits: PropTypes.object,
  creditsTotal: PropTypes.number,
  loadingCredits: PropTypes.bool,
  loggedInUser: PropTypes.object,
  more: PropTypes.func,
  onAddCredit: PropTypes.func,
  onLoadMore: PropTypes.func,
  owner: PropTypes.object,
};
export default ProjectCredits;
